// ─── Astria India v2/v3 — English/Hindi/Tamil/Marathi.
// Follows the user's preferred language (utils/appLanguage.ts): one of the
// three Indian languages when that is the preference, English otherwise.
// No per-screen toggle.
import { getAppLanguage, pickLanguage, useAppLanguage } from "../appLanguage";

export type IndiaV2Language = "en" | "hi" | "ta" | "mr";

const SUPPORTED_LANGUAGES: readonly IndiaV2Language[] = ["en", "hi", "ta", "mr"];

const resolve = (appLanguage: string): IndiaV2Language =>
  pickLanguage(appLanguage, SUPPORTED_LANGUAGES);

export const getIndiaV2Language = (): IndiaV2Language =>
  resolve(getAppLanguage());

export function useIndiaV2Language(): IndiaV2Language {
  return resolve(useAppLanguage());
}
